(() => {
  const track = (name, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
  };

  const init = (root) => {
    const section = root.querySelector?.('[data-pdp-v2-root]');
    if (!section || section.dataset.pdpV2Ready === 'true') return;
    section.dataset.pdpV2Ready = 'true';

    const productId = section.dataset.productId;
    const sticky = section.querySelector('[data-pdp-v2-sticky]');
    const stickyButton = section.querySelector('[data-pdp-v2-sticky-add]');
    const stickyPrice = section.querySelector('[data-pdp-v2-sticky-price]');
    const stickyVariant = section.querySelector('[data-pdp-v2-sticky-variant]');
    const mainProduct = () => document.querySelector('.main-product');

    const mainForm = () => mainProduct()?.querySelector('form[action*="/cart/add"]');
    const mainAdd = () => mainProduct()?.querySelector('.product-form__add-button');

    const syncSticky = () => {
      const form = mainForm();
      const add = mainAdd();
      if (!form || !add) return;
      stickyButton.disabled = add.disabled;
      stickyButton.textContent = add.textContent.trim();

      const price = mainProduct()?.querySelector('.price-list .price:not(.price--compare)');
      if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();

      const selected = [];
      form.querySelectorAll('.product-form__option input[type="radio"]:checked, .product-form__option select').forEach((input) => {
        const option = input.closest('.product-form__option');
        const rawName = option?.querySelector('.product-form__option-name')?.textContent?.trim() || '';
        const name = rawName.split(':')[0].trim();
        if (!name || name.toLowerCase() === 'variant') return;
        const label = input.id ? form.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
        const value = label?.textContent?.trim() || input.selectedOptions?.[0]?.textContent?.trim() || input.value?.trim();
        if (name && value) selected.push(`${name}: ${value}`);
      });
      if (stickyVariant) stickyVariant.textContent = selected.join(' · ');
    };

    const syncStickyVisibility = () => {
      const buyArea = mainProduct()?.querySelector('.product-form__payment-container');
      if (!sticky || !buyArea) return;
      sticky.hidden = buyArea.getBoundingClientRect().bottom >= 0;
    };
    let scrollFrame = 0;
    const queueStickyVisibility = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        syncStickyVisibility();
      });
    };
    window.addEventListener('scroll', queueStickyVisibility, { passive: true });
    window.addEventListener('resize', queueStickyVisibility, { passive: true });

    stickyButton?.addEventListener('click', () => {
      const add = mainAdd();
      if (add && !add.disabled) {
        track('pdp_v2_sticky_add_to_cart', { product_id: productId });
        add.click();
      } else {
        mainProduct()?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    document.addEventListener('change', (event) => {
      if (!mainProduct()?.contains(event.target)) return;
      const option = event.target.closest?.('.product-form__option');
      const name = option?.querySelector('.product-form__option-name')?.textContent?.trim().toLowerCase();
      if (name?.includes('size')) {
        track('pdp_v2_size_selected', { product_id: productId, value: event.target.value });
      }
      window.setTimeout(syncSticky, 80);
      window.setTimeout(syncSticky, 350);
      window.setTimeout(syncSticky, 700);
    });

    document.addEventListener('submit', (event) => {
      if (mainProduct()?.contains(event.target)) {
        track('pdp_v2_add_to_cart', { product_id: productId });
      }
    }, true);

    document.querySelectorAll('a[href="#pdp-v2-measurements"]').forEach((link) => {
      if (!section.querySelector('#pdp-v2-measurements')) {
        const block = link.closest('.product-info__block-item--text');
        if (block) {
          block.hidden = true;
          block.style.display = 'none';
        } else {
          link.hidden = true;
          link.style.display = 'none';
        }
        return;
      }
      link.addEventListener('click', () => track('pdp_v2_size_guide_click', { product_id: productId }));
    });

    section.querySelector('[data-pdp-v2-shipping]')?.addEventListener('toggle', (event) => {
      if (event.currentTarget.open) track('pdp_v2_shipping_opened', { product_id: productId });
    });

    section.querySelector('[data-pdp-v2-look]')?.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      const item = event.target.closest('[data-pdp-v2-handle]');
      if (link && item) {
        track('pdp_v2_complete_look_click', {
          product_id: productId,
          target_handle: item.dataset.pdpV2Handle,
          role: item.dataset.pdpV2Role,
        });
      }
    });

    syncSticky();
    syncStickyVisibility();
  };

  const initAll = () => document.querySelectorAll('[data-pdp-v2-root]').forEach((section) => init(section.parentElement || document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
